import React from 'react';
import { MapPinIcon, SearchIcon } from 'lucide-react';
interface InputProps {
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  icon?: 'location' | 'search';
  className?: string;
}
export const Input: React.FC<InputProps> = ({
  placeholder,
  value,
  onChange,
  icon,
  className = ''
}) => {
  return <div className={`relative ${className}`} data-id="element-89">
      {icon && <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-primary" data-id="element-90">
          {icon === 'location' ? <MapPinIcon size={20} data-id="element-91" /> : <SearchIcon size={20} data-id="element-92" />}
        </div>}
      <input type="text" placeholder={placeholder} value={value} onChange={onChange} className={`input-field ${icon ? 'pl-12' : ''}`} data-id="element-93" />
    </div>;
};